'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _ttl;

var _constants = require('../constants');

var _utils = require('../utils');

function _ttl() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
    }

    for (var i = 0; i < args.length; i++) {
        if ((0, _utils.is)(args[i].ttl, 'number')) return args[i].ttl;
    }return _constants.DEFAULT_TTL;
}